import React from 'react';
export function ProblemSection() {
  return <section className="bg-brand-grayLight py-16 px-5" data-id="element-234">
      <div className="max-w-xl mx-auto" data-id="element-235">
        <div className="bg-white border border-slate-100 rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-236">
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-8 leading-tight text-center" data-id="element-237">
            😩 ¿Te pasa esto en tu trabajo? <br data-id="element-238" />
            <span className="text-red-500" data-id="element-239">Te va a sonar familiar:</span>
          </h2>

          <div className="space-y-4 mb-12" data-id="element-240">
            {['Dudás qué fórmula usar según cada caso', 'Neutralizás… pero no siempre obtenés el resultado esperado', 'A veces corregís errores sobre la marcha', 'Te frustran manchas, bandas o reflejos no deseados', 'Sentís que dependés demasiado de prueba y error', 'Te cuesta explicar con seguridad decisiones técnicas a tus clientas', 'Sabés hacer color… pero querés trabajar con mucho más criterio'].map((problem, idx) => <div key={idx} className="bg-slate-50 border border-slate-100 p-4 rounded-xl flex items-start gap-4 transition-all hover:bg-white hover:shadow-md" data-id="element-241">
                <span className="text-red-500 text-lg flex-shrink-0" data-id="element-242">❌</span>
                <p className="text-sm md:text-base text-slate-600 font-medium leading-relaxed" data-id="element-243">
                  {problem}
                </p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-244">
            <h3 className="text-xl md:text-2xl font-bold mb-8 text-[#090909]" data-id="element-245">
              ¿Cuánto tiempo más vas a seguir formulando con dudas?
            </h3>
          </div>

          <div className="bg-[#C8A96B]/5 border border-[#C8A96B]/10 p-8 rounded-2xl mt-8" data-id="element-246">
            <p className="text-slate-900 font-bold text-lg mb-6 text-center" data-id="element-247">
              Esto es lo que cambia cuando usás este sistema:
            </p>
            <div className="space-y-4" data-id="element-248">
              {['Formulás con mayor seguridad técnica', 'Entendés por qué una mezcla funciona', 'Reducís errores costosos dentro del salón', 'Neutralizás con criterio real', 'Mejorás consistencia en tus resultados', 'Ganás más confianza frente a clientas exigentes', 'Trabajás con procesos más claros y profesionales'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-249">
                  <span className="text-[#C8A96B] font-bold text-xl" data-id="element-250">✔</span>
                  <p className="text-slate-700 text-sm md:text-base font-semibold" data-id="element-251">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}